import { InjectionToken } from '@angular/core';

export const SIDEBAR_CONTEXT = new InjectionToken<boolean>('SidebarContext');
